export default __webpack_public_path__ + "static/media/vinnuskoliMyndCut.9ea1ca37.jpg";